import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HotspotModal = ({ hotspot, onClose, onExplore, onVisitBooth }) => {
  const info = hotspot?.info;

  return (
    <>
      <div className="fixed inset-0 bg-black/50 z-40" onClick={onClose} />
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[95vw] max-w-2xl max-h-[90vh] bg-card rounded-lg shadow-2xl z-50 overflow-hidden">
        <div className="relative">
          {info?.image && (
            <div className="relative h-48 md:h-64 overflow-hidden">
              <img
                src={info?.image}
                alt={info?.imageAlt}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              <button
                onClick={onClose}
                className="absolute top-4 right-4 w-10 h-10 bg-card/90 hover:bg-card rounded-full flex items-center justify-center transition-smooth backdrop-blur-sm"
                aria-label="Close"
              >
                <Icon name="X" size={20} />
              </button>
            </div>
          )}

          {!info?.image && (
            <div className="flex items-center justify-between p-4 md:p-5 border-b border-border">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center">
                  <Icon name={hotspot?.icon} size={24} color="white" />
                </div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground">
                  {info?.title}
                </h2>
              </div>
              <Button
                variant="ghost"
                size="icon"
                onClick={onClose}
                aria-label="Close"
              >
                <Icon name="X" size={20} />
              </Button>
            </div>
          )}
        </div>

        <div className="p-4 md:p-6 overflow-y-auto max-h-[calc(90vh-280px)]">
          {info?.image && (
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
                <Icon name={hotspot?.icon} size={24} color="white" />
              </div>
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground">
                {info?.title}
              </h2>
            </div>
          )}

          <p className="text-muted-foreground mb-4 leading-relaxed">
            {info?.description}
          </p>

          {info?.capacity && (
            <div className="flex items-center gap-2 mb-4 p-3 bg-muted rounded-lg">
              <Icon name="Users" size={18} color="var(--color-primary)" />
              <span className="text-sm font-medium text-foreground">
                Capacity: {info?.capacity}
              </span>
            </div>
          )}

          {info?.facilities && info?.facilities?.length > 0 && (
            <div className="mb-6">
              <h3 className="text-sm font-semibold text-foreground mb-3 flex items-center gap-2">
                <Icon name="CheckCircle2" size={16} color="var(--color-primary)" />
                Available Facilities
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                {info?.facilities?.map((facility, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-2 p-2 bg-muted rounded-lg"
                  >
                    <Icon name="Check" size={14} color="var(--color-success)" />
                    <span className="text-sm text-foreground">{facility}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="flex flex-col sm:flex-row gap-3 pt-4 border-t border-border">
            {info?.linkedLocation && (
              <Button
                variant="default"
                fullWidth
                iconName="Navigation"
                iconPosition="left"
                onClick={() => onExplore(info?.linkedLocation)}
              >
                Explore This Location
              </Button>
            )}
            {hotspot?.type === 'building' && (
              <Button
                variant="outline"
                fullWidth
                iconName="Building2"
                iconPosition="left"
                onClick={onVisitBooth}
              >
                Visit Virtual Booth
              </Button>
            )}
            {!info?.linkedLocation && hotspot?.type !== 'building' && (
              <Button
                variant="outline"
                fullWidth
                iconName="Bookmark"
                iconPosition="left"
              >
                Save for Later
              </Button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default HotspotModal;